import toast from "react-hot-toast";
import { formatDateToLocal } from "../../utils/utils";

const { clientAPI } = require("../client");
export const attendanceCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/attendance", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/attendance/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/attendance/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search) options.search = param.search;
      if (param.department) options.department = param.department;
      if (param.branchId) options.branchId = param.branchId;
      if (param.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param.saleAreaId) options.saleAreaId = param.saleAreaId;
      if (param.supportDepartmentId)
        options.supportDepartmentId = param.supportDepartmentId;
      if (param.date) options.date = formatDateToLocal(param.date);
      if (param.status !== null && param.status !== undefined && param.status !== "")
        options.status = param.status;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/attendance?${queryParams}`);

      const dataExport = response?.items.map((item, index) => {
        return {
          date: item?.month && item?.year ? item?.month + "/" + item?.year : "",
          codeEmployee: item?.employeeObject?.code || "",
          fullName: item?.employeeObject?.fullName || "",
          saleBlock: item?.saleBlock?.name || "",
          saleArea: item?.saleArea?.name || "",
          jobPosition: item?.jobPosition?.name || "",
          commissionRate: item?.commissionRate || "",
          workingDays: item?.workingDays || "",
          businessCategory: item?.businessCategory?.name || "",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getByEmployee: async (employeeId, month, year) => {
    try {
      const response = await clientAPI(
        "get",
        `/attendance/getByEmployeeId/${employeeId}?month=${month}&year=${year}`,
      );
      return response;
    } catch (error) {
      console.error("Get by id error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getCertificateOrDepositByLockingIdAndEmployeeId: async (
    employeeId,
    lockingId,
  ) => {
    try {
      const response = await clientAPI(
        "get",
        `/brokerDebtCertificate/locking/employee/?employeeId=${employeeId}&lockingId=${lockingId}`,
      );
      return response;
    } catch (error) {
      console.error("Get by id error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getCertificateByEmployeeId: async (employeeId) => {
    try {
      const response = await clientAPI(
        "get",
        `/brokerDebtCertificate/employee/${employeeId}`,
      );
      return response;
    } catch (error) {
      console.error("Get by id error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getCertificateByEmployeeIds: async (lockingId, employeeIds) => {
    const params = new URLSearchParams();

    params.set("lockingId", lockingId);

    employeeIds.forEach((id) => {
      params.append("employeeIds", id);
    });

    const queryParams = params.toString();

    try {
      const response = await clientAPI(
        "get",
        `/brokerDebtCertificate/list-by-employe-ids?${queryParams}`,
      );
      return response;
    } catch (error) {
      console.error("Get by id error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  importAttendanceSupportBusiness: async (input, name) => {
    try {
      const data = {
        input,
        name
      };
      const response = await clientAPI(
        "post",
        "/attendance/import/support-business/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  importAttendanceBusiness: async (input, name) => {
    try {
      const data = {
        input,
        name
      };
      const response = await clientAPI(
        "post",
        "/attendance/import/business/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateEliteByMonth: async (month, year) => {
    try {
      const response = await clientAPI(
        "post",
        "/attendance/update-elite",
        { month, year },
      );
      return response;
    } catch (error) {
      console.error("Update elite error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  // Xuất bảng công của 1 tháng (chốt bảng công): lấy tổng số bản ghi rồi lấy toàn bộ.
  // Cột khác nút Xuất excel: thêm Trưởng khối, Trưởng vùng, Công chuẩn; bỏ Tỉ lệ phí dịch vụ
  exportByMonth: async (param) => {
    try {
      const options = {
        limit: 1,
        page: 1,
        date: formatDateToLocal(param.date),
      };
      if (param.departments) options.departments = param.departments;

      const first = await clientAPI(
        "get",
        `/attendance?${new URLSearchParams(options).toString()}`,
      );
      const total = first?.pagination?.total || 0;
      if (!total) return [];

      options.limit = total;
      const response = await clientAPI(
        "get",
        `/attendance?${new URLSearchParams(options).toString()}`,
      );

      return response?.items.map((item) => ({
        date: item?.month && item?.year ? item?.month + "/" + item?.year : "",
        codeEmployee: item?.employeeObject?.code || "",
        fullName: item?.employeeObject?.fullName || "",
        saleBlock: item?.saleBlock?.name || "",
        saleArea: item?.saleArea?.name || "",
        saleBlockManager: item?.saleBlockManager?.fullName || "",
        saleAreaManager: item?.saleAreaManager?.fullName || "",
        jobPosition: item?.jobPosition?.name || "",
        workingDays: item?.workingDays || "",
        totalStandardWorking: item?.totalStandardWorking || "",
        businessCategory: item?.businessCategory?.name || "",
      }));
    } catch (error) {
      console.error("Export by month error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  lock: async (month, year, departments) => {
    try {
      const data = { month, year };
      if (departments?.length) data.departments = departments;
      const response = await clientAPI("post", "/attendance/lock", data);
      return response;
    } catch (error) {
      console.error("Lock attendance error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  unlock: async (id) => {
    try {
      const response = await clientAPI("put", `/attendance/${id}/unlock`);
      return response;
    } catch (error) {
      console.error("Unlock attendance error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateStandardWorking: async (month, year, totalStandardWorking) => {
    try {
      const response = await clientAPI(
        "post",
        "/attendance/standard-working",
        { month, year, totalStandardWorking },
      );
      return response;
    } catch (error) {
      console.error("Update standard working error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  rebuildMonthlyEmployeeStatistics: async (month, year) => {
    try {
      const response = await clientAPI(
        "post",
        "/document/monthly-employee-statistics/rebuild-statistics",
        { month, year },
      );
      return response;
    } catch (error) {
      console.error("Rebuild monthly employee statistics error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
